module.exports = __webpack_public_path__ + "img/spiral-details16.431e41bb.png";